

<!-- <ion-header>
  <ion-toolbar style="background-color: red;">
    <ion-title>History Of STT Model Inferencing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header> -->


<ion-header>
  <ion-toolbar style="background-color: red;">
    <ion-title>STT Model Inferencing History</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-row style="background-color: #f1f1f1;">
    
    <ion-col size="2" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-label position="floating">Filter User</ion-label>
              <ion-select [(ngModel)] = "selectedOptionUser" (ionChange)="onOptionChangeForUser($event)">
                <ion-select-option *ngFor="let option of optionsUser" [value]="option.value">
                  {{ option.label }}
                </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>

    <ion-col size="4" style="display: revert;padding:0px 10px"></ion-col>


    <ion-col size="3" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-input [(ngModel)]="searchQuery" (ionInput)="onSearchInputChange()" (keyup.enter)="onSearch()" placeholder="Search..."></ion-input>
        <ion-icon class="search-icon" name="search" slot="end" title="search" (click)="onSearch()"></ion-icon>
        <ion-icon name="close-circle" slot="end" *ngIf="searchQuery"  (click)="clearSearch()"></ion-icon>
      </ion-item>      
    </ion-col>   

  </ion-row>
</ion-header>

  
<ion-content class="no-hover-page" [fullscreen]="true">
  <ng-container >
    <ion-card *ngIf="textListData.length > 0; else nodata"  style="padding-bottom: 90px;">
      <!-- <ion-grid style="margin-bottom: 80px;"> -->
        <!-- Table Headers -->
        <ion-row class="table-header">
          <ion-col size="1"><strong>Index</strong></ion-col>
          <ion-col size="5"><strong>Text</strong></ion-col>
          <ion-col size="2"><strong>Text Match</strong></ion-col>
          <ion-col size="2"><strong>Remarks</strong></ion-col>
          <!-- <ion-col size="2"><strong>Sound File</strong></ion-col> -->
          <!-- <ion-col size="2"><strong>Transcribed Text</strong></ion-col> -->
          <!-- <ion-col size="1"></ion-col> -->

          <ion-col size="1"><strong>User</strong></ion-col>
          <!-- <ion-col size="1"><strong>Own Count</strong></ion-col> -->
          <!-- <ion-col size="1"><strong>Total Count</strong></ion-col> -->
          <ion-col size="1" style="padding-left: 25px;"><strong>Actions</strong></ion-col>
        </ion-row>
    
        <!-- Table Rows -->
         
        <ion-row *ngFor="let item of textListData; let i = index" class="table-row">
          <ion-col size="1">{{ i + 1 }}</ion-col>
          <!-- <ion-col size="4" class="clickable-text" (click) = "openTextRecorFormModal(item)">{{ item.Text }}</ion-col> -->
          <ion-col size="5">
            <div>
              <p><strong>Original Text:</strong></p>
              <p>{{ item.text }}</p>
              <p><strong>Transcribed Text:</strong></p>
              <p>{{ item.transcribed_text }}</p>
              <p *ngIf="item.remarks"><strong>Remarks:</strong></p>
              <p *ngIf="item.remarks">{{ item.remarks }}</p>

              <audio controls *ngIf="item.audio_link" preload="none">
                <source [src]="item.audio_link" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>

            </div>

          </ion-col>
          <!-- <ion-col size="2" [ngStyle]="{ color: item.text === item.transcribed_text ? 'green' : 'red' }">
            {{ item.text === item.transcribed_text ? 'Matched' : 'Not matched' }}
          </ion-col> -->
          <ion-col size="2" [ngStyle]="{ color: isTextMatched(item.text, item.transcribed_text) ? 'green' : 'red' }">
            {{ isTextMatched(item.text, item.transcribed_text) ? 'Matched' : 'Not matched' }}
          </ion-col>

          <ion-col size="2">{{ item.remarks }}</ion-col>
          <ion-col size="1">{{ item.user }}</ion-col>

          <!-- <ion-col size="1" class="clickable-text">{{ item.InferenceCountOwn }}</ion-col> -->
          <!-- <ion-col size="1">{{ item.InferenceCountOwn }}</ion-col> -->

          <!-- <ion-col size="1" class="clickable-text">{{ item.InferenceCountTotal }}</ion-col> -->
          <!-- <ion-col size="1">{{ item.InferenceCountTotal }}</ion-col> -->

          <ion-col size="1">
            <div class="tooltip-wrapper">
              <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteSTTInferencedData(item)">
              <!-- <ion-button class="zoom-icon-button" fill="clear" color="primary" disabled> -->
                <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
              </ion-button>
              <span class="custom-tooltip">Delete Text</span>
            </div>
          </ion-col>
        </ion-row>
        
      <!-- </ion-grid> -->
    </ion-card>
    <!-- No Data Available Message -->
    <ng-template #nodata>
      <ion-card>
        <ion-row>
          <ion-col>No data available.</ion-col>
        </ion-row>
      </ion-card>
    </ng-template>
  </ng-container>  
</ion-content>

<ion-footer class="pagination-footer">
  <ion-toolbar>
    <ion-row class="pagination-row">
      <!-- First & Previous Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === 1" (click)="goToFirstPage()">
          <ion-icon name="play-back-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === 1" (click)="prevPage()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Page Number Display -->
      <ion-col size="auto" class="text-center">
        <ion-item lines="none">
          <span>{{ currentPage }} / {{ totalPages }}</span>
        </ion-item>
      </ion-col>

      <!-- Next & Last Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === totalPages" (click)="nextPage()">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === totalPages" (click)="goToLastPage()">
          <ion-icon name="play-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Go to Specific Page Input -->
      <ion-col size="auto">
        <ion-item lines="none">
          <ion-input type="number" [(ngModel)]="currentPage" placeholder="Page #" min="1" [max]="totalPages"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="auto">
        <ion-button [disabled]="!currentPage || currentPage < 1 || currentPage > totalPages" 
                    (click)="goToSpecificPage(currentPage)">
          GO
        </ion-button>
      </ion-col>

      <!-- Page Size Selector -->
      <ion-col size="auto">
        <ion-item>
          <!-- <ion-label>Page Size</ion-label> -->
          <ion-select [(ngModel)]="pageSize" (ionChange)="onPageSizeChange()">
            <ion-select-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>


    </ion-row>
  </ion-toolbar>
</ion-footer>
    



  



